import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import {
	WithStyles,
	Button,
	Typography,
	Grid,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import Chip from '@material-ui/core/Chip';
import courseService from '../../services/courseService';
import { showMsg } from '../../actions/loaderAlert';
import{styles} from '../../styling/component/CourseDetail/ContentShareModel'


import {  MyPATDialog, SearchField } from '../../../common';
import ContentData from '../../../mylibrary/types/ContentData';
import { UserData } from '../../../mylibrary/types/ContentData';
import { UserGroupsBody } from '../../../mylibrary/types/UserGroupsBody';
import userService from '../../../mylibrary/services/userService';
import { usersList } from '../../../mylibrary/actions/userActions';
import { getCourseID } from './commonFunction';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

//@ts-ignore
interface Props extends WithStyles<typeof styles> {
	classes: any,
	contentList: ContentData[]
	isShareDialogOpen: boolean,
	onShared: Function,
	users: UserData[]
    usersList: Function,
	closeDialog:Function,
	showMsg: (msg: string, vari: string) => void,
	courseID:string,
	courseData:any,
	functionCall:Function,
	match:any
}
interface States {
	selectedUsers: any[],
	selectedGroups: UserGroupsBody[],
	selectedPermission: string,
	// users: UserData[],
	groups: UserGroupsBody[],
	removedIds: string[],
	suggestedList: any[],
	showSuggestedList: boolean,
	showFullAlreadyShared: boolean,
	alreadySelected:any[],
	alreadySharedUser:any[],
	alreadySharedGroup:any[],
	allSharedId: any[]
}

class ContentShareModal extends Component<Props, States> {
	state = {
		selectedUsers: [],
		selectedGroups: [],
		selectedPermission: 'VIEW',
		groups: [],
		showSuggestedList: false,
		suggestedList: [],
		removedIds: [],
		showFullAlreadyShared: false,
		alreadySelected:[],
		alreadySharedUser:[],
		alreadySharedGroup:[],
		allSharedId:[]
	};

	constructor(props: Props) {
		super(props);

		this.onShared = this.onShared.bind(this);
		this.setPermission = this.setPermission.bind(this);
		this.suggest = this.suggest.bind(this);
		this.showSuggested = this.showSuggested.bind(this);
		this.filterSharedGroupsUser=this.filterSharedGroupsUser.bind(this);
	}


	componentDidMount() {
		_.isEmpty(this.props.users) && this.props.usersList();
		userService.group().then(groups => {
			this.setState({ groups });
		})
	
	}

	componentDidUpdate(prevProps:any) {
		// Typical usage (don't forget to compare props):
		if (this.props.isShareDialogOpen !== prevProps.isShareDialogOpen) {
			this.filterSharedGroupsUser()
		}
	  }

	filterSharedGroupsUser(){
		let self = this
		const {courseData} = this.props

		let contentList = courseData || []

		let allowedToArr = _.get(contentList, 'aclMetaData.allowedTo', []);
		let tempUserArr: any[]=[]
		let tempGroupArr: any[]=[]
		let allSharedIds: any[] = []

		allowedToArr.map(function(value:any){
			let userid = _.get(value, 'user.id')
			let userGroup = _.get(value, 'userGroup.id')
			if(userid == null){
				tempGroupArr.push(value)
			}else if(userGroup == null){
				tempUserArr.push(value)
			}
		}) 

		_.forEach(tempUserArr , (data:any) => {
			allSharedIds.push(data.user.id._id)
		})
		

		this.setState({
			alreadySharedUser:tempUserArr,
			alreadySharedGroup:tempGroupArr,
			allSharedId: allSharedIds
		})	

	}

	setPermission(e: any) {
		let { value } = e.target;
		this.setState({ selectedPermission: value });
	}

	showSuggested(action: boolean) {
		if (action) {
			this.setState({ showSuggestedList: true });
		} else {
			setTimeout(() => { this.setState({ showSuggestedList: false }); }, 200)
		}
	}

	suggest(e: any) {
		const { users } = this.props;
		const { groups } = this.state;
		let suggestedList: any[] = this.state.suggestedList;
		let { value } = e.target;
		value = value.toLocaleLowerCase();
		suggestedList = [];
		users.forEach((u: UserData) => {
			if ((u.fullName && u.fullName.toLocaleLowerCase().search(value) != -1) || (u.email && u.email.toLocaleLowerCase().search(value) != -1)) {
				suggestedList.push({ _id: u._id, name: u.fullName, type: "user" })
			}
		})

		groups.forEach((ug: UserGroupsBody) => {
			if (ug.name && ug.name.toLocaleLowerCase().search(value) != -1) {
				suggestedList.push({ _id: ug._id, name: ug.name, type: "group" })
			}
		})

		suggestedList = _.take(suggestedList, 3);

		this.setState({ suggestedList });
	}

	choosed(id: string, type: string) {
		let { users,courseData} = this.props;
		let { groups, selectedUsers, selectedGroups,selectedPermission }: any = this.state;
		let contentList = courseData || []
		let getSharedItems = _.get(contentList, 'aclMetaData.allowedTo', []);

		getSharedItems = getSharedItems.filter(function(value:any){
			let userid = _.get(value, 'user.id._id', _.get(value, 'userGroup.id._id', ''))
			return id == userid && value.accessAllowed.includes(selectedPermission)
		})

		if(getSharedItems.length>0){
			this.props.showMsg("Already Shared !", 'error');
			return
		}

		if (type == 'user') {
			selectedUsers = [...selectedUsers.filter((u: UserData) => u._id != id), ...users.filter((u: UserData) => u._id == id)];
		} else {
			selectedGroups = [...selectedGroups.filter((ug: UserGroupsBody) => ug._id != id), ...groups.filter((ug: UserGroupsBody) => ug._id == id)];
		}

		this.setState({ selectedUsers, selectedGroups });
	}

	removeSelected(id: string, type: string) {
		let { selectedUsers, selectedGroups } = this.state;
		if (type == 'user') {
			selectedUsers = selectedUsers.filter((u: UserData) => u._id != id);
		} else {
			selectedGroups = selectedGroups.filter((ug: UserGroupsBody) => ug._id != id);
		}

		this.setState({ selectedUsers, selectedGroups });
	}

	removeAlreadyExist(c: any) {
		let removedIds: string[] = this.state.removedIds;
		removedIds.push(_.get(c, 'user.id._id', _.get(c, 'userGroup.id._id', '')));
		this.setState({
			removedIds:removedIds
		})	
	}

	onShared() {
			const {courseID,courseData} = this.props
			const {selectedPermission,selectedGroups,alreadySharedGroup,alreadySharedUser} = this.state
			var self = this

			let contentList = courseData || []
			let getSharedItems = _.get(contentList, 'aclMetaData.allowedTo', []);
			let removedIds: string[] = this.state.removedIds;
			let selectedUsers: UserData[] = this.state.selectedUsers;
			let tempUserArr: any[]=[]
			let tempGroupArr: any[]=[]
			alreadySharedGroup.map(function(value:any){
				let userid = _.get(value, 'user.id._id', _.get(value, 'userGroup.id._id', ''));
				let permission = value.accessAllowed.includes("EDIT")?"EDIT":"VIEW"
				if(!removedIds.includes(userid)){
					tempGroupArr.push({
						userId: userid,
						permission:permission
					})
				 }
			})
			alreadySharedUser.map(function(value:any){
				let userid = _.get(value, 'user.id._id', _.get(value, 'userGroup.id._id', ''));
				let permission = value.accessAllowed.includes("EDIT")?"EDIT":"VIEW"
				if(!removedIds.includes(userid)){
					tempUserArr.push({
						userId: userid,
						permission:permission
					})
				 }
			})

			let body = {
				userList: [...selectedUsers.map((u:any) => {return {userId:u._id,permission:selectedPermission}}),...tempUserArr],
				userGroupList:  [...selectedGroups.map((u:any) => {return {userId:u._id,permission:selectedPermission}}),...tempGroupArr],
			}
			
			if(body.userList && body.userList.length > 0){
				courseService.shareCourseWithUser(courseID,body)
				.then((res) => {
					if(res.status == 200){
						this.setState({ removedIds: [], suggestedList: [], selectedUsers: [], selectedGroups: [], showSuggestedList: false });
						this.props.closeDialog()
						self.props.showMsg("Successfully Shared !", 'success');
						this.props.functionCall()
					}else{
						self.props.showMsg("Failed to share !", 'success');
					}
				})
			}
			else{
				self.props.showMsg("Failed to share !", 'failed');
			}
			//this.setState({ removedIds: [], suggestedList: [], selectedUsers: [], selectedGroups: [], showSuggestedList: false });
			//this.props.closeDialog()
	}
	

	render() {
		const { classes, isShareDialogOpen, users ,courseData} = this.props;
	

		const { selectedUsers, selectedGroups, showSuggestedList, suggestedList, showFullAlreadyShared, allSharedId } = this.state;
		const removedIds: string[] = this.state.removedIds;
		let othersShared = 0;
		let contentList = courseData || []
		let getSharedItems = _.get(contentList, 'aclMetaData.allowedTo', []);
		var _self =this
		return (
			<div>
				<MyPATDialog
					dialogOpen={isShareDialogOpen}
					dialogHeading="Share this Course with others"
					variantHeader="leftHeader"
					onDialogClose={this.props.closeDialog}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					variant="white"
					customDialogActions={
						<>
							{
								(selectedUsers.length > 0 || selectedGroups.length > 0 || removedIds.length > 0) && (
									<Button variant="contained" color="primary" onClick={() => { this.onShared() }}>Share</Button>
								)
							}

							<Button
								color="primary"
								onClick={() => { this.props.closeDialog() }}>
								Cancel
              </Button>
						</>
					}
				>
					<Grid container alignItems="flex-end">
						<Grid item xs={6}>
							<Typography variant="body2" className={classes.peopleText}>People</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<select className={classes.permissionSelect} onChange={this.setPermission}>
								<option value="VIEW">View Only</option>
								<option value="EDIT">Can Edit</option>
							</select>
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs>

							{
								_.map(selectedUsers, (u: UserData) => (
									<Chip
										key={`userDetail_${u._id}`}
										classes={{ root: classes.userChipRoot, label: classes.userChipLabel }}
										label={u.fullName}
										onDelete={() => { this.removeSelected(u._id, 'user') }}
										deleteIcon={<CloseIcon className={classes.userChipIcon} />}
									/>
								))
							}
							{
								_.map(selectedGroups, (u: UserGroupsBody) => (
									<Chip
										key={`userGroup_${u._id}`}
										classes={{ root: classes.userChipRoot, label: classes.userChipLabel }}
										label={u.name}
										onDelete={() => { this.removeSelected(u._id, 'group') }}
										deleteIcon={<CloseIcon className={classes.userChipIcon} />}
									/>
								))
							}
						</Grid>
					</Grid>

					<div className={classes.suggestContainer}>
						<SearchField
							placeholder="Enter Users, Groups or email addresses..."
							className={classes.searchRoot}
							onFocus={() => { this.showSuggested(true) }}
							onBlur={() => { this.showSuggested(false) }}
							onChange={this.suggest}
							fullWidth
						/>	
						{
							showSuggestedList && suggestedList.length > 0 && (
								<ul className={classes.suggestList}>
									{	
										_.map(suggestedList, (sl: any, i: number) => _.isEmpty(_.find(selectedUsers, ['_id', sl._id])) && !_.includes(allSharedId, sl._id) &&  (
											<li key={`suggest_${i}`} className={classes.suggestItem} onClick={() => { this.choosed(sl._id, sl.type); }}>
												{sl.name}
											</li>
										)
										)
									}
								</ul>
							)
						}
					</div>
					<Grid container>
					
						<Grid item xs={12}>
						<Typography variant="body2" inline className={classes.sharedWithText}>Already Shared with:</Typography>
							{
								getSharedItems.map(function(c:any,i:number){

									if (_.get(c, 'user.id._id', _.get(c, 'userGroup.id._id', '')) == "") {
										return;
									}
									if (removedIds.includes(_.get(c, 'user.id._id', _.get(c, 'userGroup.id._id', '')))) {
										othersShared++;
										return;
									}

									if (!showFullAlreadyShared && i > 1) {
										return;
									}

									return	<>
									
											<Chip
												key={i}
												classes={{ root: classes.userChipRoot, label: classes.userChipLabel }}
												label={_.get(c, 'user.id.firstName', _.get(c, 'userGroup.id.name', '1'))}
												deleteIcon={<CloseIcon className={classes.userChipIcon} />}
												onDelete={() =>  _self.removeAlreadyExist(c) }
											/>
									
									</>
								})
							}

							{
								(getSharedItems.length - removedIds.length - othersShared) > 2 && !showFullAlreadyShared && (
									<Typography
										variant="body2"
										color="textSecondary"
										onClick={() => { this.setState({ showFullAlreadyShared: true }) }}
										inline
									>
										+{getSharedItems.length - removedIds.length - othersShared - 2} more
		</Typography>
								)
							}

							{
								getSharedItems.length - removedIds.length - othersShared > 2 && showFullAlreadyShared && (
									<Typography
										variant="body2"
										color="textSecondary"
										onClick={() => { this.setState({ showFullAlreadyShared: false }) }}
										inline
									>
										 &nbsp;less
		</Typography>
								)
							}
							
						</Grid>
					</Grid>

				</MyPATDialog>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'mylibraryData.users.list', []),
	courseData: state.courseData.courseData.list
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	usersList,
	showMsg: showMsg
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContentShareModal));
